import { useState } from 'react';
import { Tabs, TabsList, TabsTrigger, TabsContent } from "@Components/shadcn/ui/tabs";
import UserDetailsComponent from '@Pages/UserDetails/components/UserDetailsComponent';
import Channels from '@Pages/Channels';
import { Cog6ToothIcon } from '@heroicons/react/24/solid';
import posthog from 'posthog-js';
import { AnalyticsParamBuilder } from '@Utils/common';
import { RootState, useAppSelector } from '@Store/store';


const COMPONENT = "settings"
const Setting = () => {
  const [workspaceName, setWorkspaceName] = useState('Aviral Saxena');

  const { user } = useAppSelector((state: RootState) => state.profile);

  const handleWorkspaceNameUpdate = () => {
    // TODO: Implement workspace name update logic
  };

  const handleRefreshPermissions = () => {
    // TODO: Implement refresh permissions logic
  };

  const handleTabChange = (value: string) => {
    posthog.capture("ui_action", AnalyticsParamBuilder({
      kingdom: COMPONENT,
      phylum: "change_tab",
      str_value: value,
    }));
  }

  return (
    <div className="min-h-screen  p-6">
      <div className="max-w-4xl mx-auto space-y-6">
        <div className="flex items-center gap-2">
          <Cog6ToothIcon className='size-6' />
          <h1 className="text-2xl font-semibold">Settings</h1>
        </div>

        <Tabs defaultValue="general" className="w-full" onValueChange={handleTabChange} >
          <TabsList className="bg-white border-b border-gray-200 w-full justify-start rounded-none px-6">
            <TabsTrigger value="general" className="data-[state=active]:border-b-2 data-[state=active]:border-purple-600 rounded-none">
              General
            </TabsTrigger>
            <TabsTrigger value="channels" className="data-[state=active]:border-b-2 data-[state=active]:border-purple-600 rounded-none">
              Instagram Accounts
            </TabsTrigger>
            {user?.user_id == 7920 && <TabsTrigger value="billing" className="data-[state=active]:border-b-2 data-[state=active]:border-purple-600 rounded-none">
              Billing
            </TabsTrigger>}
          </TabsList>

          <TabsContent value="general" className="bg-white rounded-lg p-6 mt-6">
            <div className="space-y-6">
              <div>
                <h2 className="text-xl font-semibold mb-4">General</h2>
                <p className="text-gray-600 mb-6">Change the settings for your current workspace</p>
              </div>

              <UserDetailsComponent />

              {/* <div className="pt-6 border-t border-gray-200">
                <h3 className="font-medium mb-2">Instagram Permissions</h3>
                <p className="text-sm text-gray-500 mb-4">
                  Instagram can unexpectedly lose the connection to your page permissions. If you encounter any trouble, like content not sending or setting not saving, always refresh your permissions first.
                </p>
                <button
                  onClick={handleRefreshPermissions}
                  className="w-full bg-purple-600 text-white py-2 rounded-lg hover:bg-purple-700 transition-colors"
                >
                  Refresh Permissions
                </button>
              </div> */}
            </div>
          </TabsContent>

          <TabsContent value="channels" className="bg-white rounded-lg p-6 mt-6">
            <div>
              <h2 className="text-xl font-semibold mb-4">Instagram Accounts</h2>
              <p className="text-gray-600 mb-6">Manage your connected Instagram Accounts</p>

              {/* Add channel management content here */}
              <Channels />
            </div>
          </TabsContent>

          {
            user?.user_id == 7920 &&
            <TabsContent value="billing" className="bg-white rounded-lg p-6 mt-6">
              <div className="min-h-screen bg-white text-gray-900 px-6 py-10">
                {/* Header */}
                <div className="max-w-3xl mx-auto">
                  <h1 className="text-3xl font-bold mb-2">Plan & Billings</h1>
                  <p className="text-gray-600 mb-8">
                    View your subscription plan, billings information.
                  </p>

                  {/* Subscription Plan */}
                  <div className="bg-white rounded-lg border border-gray-200 shadow-sm mb-8">
                    <div className="p-6 border-b border-gray-200">
                      <h2 className="text-lg font-semibold mb-1">Subscription Plan</h2>
                    </div>
                    <div className="p-6 space-y-4">
                      {/* Current Plan */}
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                        <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between w-full">
                          <p className="text-gray-500 mb-1 sm:mb-0">Current Plan</p>
                          <p className="text-md font-semibold text-gray-900">PRO Annual</p>
                        </div>
                      </div>

                      {/* Plan Renewable Date */}
                      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between">
                        <p className="text-gray-500 mb-1 sm:mb-0">Plan Renewable Date</p>
                        <p className="text-md font-semibold text-gray-900">3rd October 2026</p>
                      </div>
                    </div>

                  </div>

                  {/* Billing History */}
                  <div className="bg-white rounded-lg border border-gray-200 shadow-sm">
                    <div className="p-6 border-b border-gray-200">
                      <h2 className="text-lg font-semibold mb-1">Billing History</h2>
                    </div>
                    <div className="overflow-x-auto">
                      <table className="min-w-full text-left text-gray-700">
                        <thead className="border-b border-gray-200 text-sm bg-gray-50">
                          <tr>
                            <th className="py-3 px-4 font-medium">Name</th>
                            <th className="py-3 px-4 font-medium">Amount</th>
                            <th className="py-3 px-4 font-medium">Date</th>
                            <th className="py-3 px-4 font-medium">Operation</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr className="border-t border-gray-200 hover:bg-gray-100">
                            <td className="py-3 px-4">Pro Plan</td>
                            <td className="py-3 px-4">₹5650</td>
                            <td className="py-3 px-4">2025/10/04 01:02am</td>
                            <td className="py-3 px-4">
                              <a
                                href="https://linkplease.co/wp-content/uploads/2025/10/Invoice.pdf"
                                target="_blank"
                                className="text-blue-600 hover:underline font-medium"
                              >
                                Obtain invoice
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </TabsContent>
          }
        </Tabs>
      </div>
    </div>
  );
};

export default Setting;